export default __webpack_public_path__ + "static/brain-d37e703ae7ef54ef208b88a98cc99ffc.svg";